import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import axios from 'axios';
import {axiosInstance} from "../axiosInstance.jsx"
import { useNavigate } from "react-router-dom";


const CategoryTabs = ({ selectedCategory }) => {
  const [categories, setCategories] = useState(['All']);
  const [value, setValue] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axiosInstance.get('/categories').then((res) => {
      setCategories(['All', ...res.data.categories.filter(cat=>cat!='')]);
    });

  }, []);

  useEffect(() => {
    const selectedIndex = categories.indexOf(selectedCategory);
    if (selectedIndex !== -1) {
      setValue(selectedIndex);
    }
  }, [selectedCategory, categories]);

  const handleChange = (event, newValue) => {
    const cat = categories[newValue];
    // window.location.href = `/${cat}/1`;  
    navigate(`/${cat}/1`); 
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        {categories.map((cat, index) => (
          <Tab key={index} label={cat} />
        ))}
      </Tabs>
    </Box>
  );
};

export default CategoryTabs;
